<ion-header>
    <ion-toolbar>
        <ion-title>Equipment List</ion-title>
        <ion-buttons slot="start">
            <ion-button (tap)="cancelModal()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button color="danger" size="small" slot="end" shape="round" (click)="delete = !delete">
                <ion-icon slot="icon-only" name="trash" color="danger"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-row *ngIf="document.documentType !== 7">
    <ion-col size="6">
        <ion-button expand="full" color="light" (click)="addEquipmentModal()" shape="round">Add Plant</ion-button>
    </ion-col>
    <ion-col size="6">
        <ion-button expand="full" color="light" (click)="addProductModal()" shape="round">Add Product</ion-button>
    </ion-col>
</ion-row>

<ion-row *ngIf="document.documentType === 7">
    <ion-col size="12">
        <ion-button expand="full" color="light" (click)="addProductModal()" shape="round">Add Product</ion-button>
    </ion-col>
</ion-row>

<ion-content>
    <ion-list>
        <ion-item *ngFor="let det of detailsArr; index as i">
            <p (click)="editDetailLine(det)">{{det.qty}} X {{det.description}}</p>
            <ion-icon *ngIf="delete" slot="end" name="trash" (click)="detailsArr.splice(i,1)" color="danger"></ion-icon>
        </ion-item>
    </ion-list>

</ion-content>

<ion-footer>
    <p text-center style="color: darkgrey">The items are saved automatically</p>
</ion-footer>
